import './Hero.css';

export default function Hero() {
  return (
    <section className="hero" id="top">
      <div className="hero-bg">
        <img src="/images/vkm_pond.jpg" alt="Rural India landscape" />
        <div className="hero-overlay" />
      </div>
      <div className="hero-content">
        <h1 className="hero-headline">
          Reimagining<br />
          <em>Rural Livelihoods.</em>
        </h1>
        <p className="hero-sub">
          We build and back businesses across rural and peri-urban India -
          creating lasting, sustainable economic opportunities for decentralized prosperity.
        </p>
        <div className="hero-cta">
          <a href="#about" className="btn-primary">Our Story</a>
          <a href="#portfolio" className="btn-ghost">What We Do</a>
        </div>
      </div>
    </section>
  );
}
